var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMapPinOutlineinline = function SvgMapPinOutlineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.263 3.487a6.029 6.029 0 0 0-9.059 7.917L7 17.698l4.796-6.294a6.029 6.029 0 0 0-.533-7.917ZM2.05 2.8a7 7 0 0 1 10.518 9.192L7 19.3l-5.568-7.308A7 7 0 0 1 2.05 2.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.999 9.92a2.212 2.212 0 1 0 0-4.423 2.212 2.212 0 0 0 0 4.424Zm0 1.026a3.237 3.237 0 1 0 0-6.474 3.237 3.237 0 0 0 0 6.474Z",
    fill: "currentColor"
  })));
};
export default SvgMapPinOutlineinline;